import request from "@/utils/request";
import {JSEncrypt} from "jsencrypt";
import {getVata, getywsj} from "@/assets/js/common";
import {toolascii, toolpart} from "@/utils/tool";
import {binaryToString, deobfuscateKey, getSystempart} from "@/assets/js/system";

//常量是已混淆的公钥
var pppval =  process.env.VUE_APP_KEY_PUB;

const keyPart1 = toolascii(getSystempart());
const keyPart2 = binaryToString(toolpart());

//用于混淆公钥
var REPLACEMENT_MAP = (function() {
  // 私有数据存储
  var _data = {
    "&&a0a0hyHasg0a0a": '0',
    "&&hh1h1vag271h1h": '1',
    "&&pp2h2sakKzwb2h": '2',//
    "&&k3o32r1bhb3o3k": '3',
    "&&k43s22d21bhbs4": '4',
    "&&k5o32F1bhb3o3k": '5',
    "&&k5o65GG321bhb3": '6',
    "&&h77o7h2gasgL6g": '7',
    "&&a4S4a0hyasg0a0": '8',
    "&&a12aG0hyasg0a0": '9',
    "&&a0a0hwyasg0a21": 'a',
    "&&h32h1Fva271h1h": 'b',
    "&&h1h1iaju21631h": 'c',//
    "&&p1shwSssakzwb2": 'd',
    "&&p2h2Ksakzwb2h2": 'e',
    "&&p2h21F1Akzwb2h": 'f',
    "&&h7ii7a0HYadsg6": 'g',
    "&&k5o6p5o321bhb3": 'h',
    "&&i56ii7a0shyasg": 'i',
    "&&7j77jkaDh22hg8": 'j',
    "&&6j732jQjayzv54": 'k',
    "&&6j66jdjayzv54j": 'l',
    "&&6j66jjayDzv66j": 'm',
    "&&dad2e13A24112a": 'n',
    "&&12a31LKd324234": 'o',
    "&&32421fs465D75W": 'p',
    "&&Kawu1123123Sgs": 'q',
    "&&haha231s8hajsh": 'r',
    "&&kk213d18agasds": 's',
    "&&hehe13WC23adds": 't',
    "&&huohuo2s71129h": 'u',
    "&&loawsGeasdsd32": 'v',
    "&&123S1vsdac3432": 'w',
    "&&123d2cAdasf324": 'h',
    "&&123Vasdaf32412": 'y',
    "&&123s1Sdsdas322": 'z',
    "&&kahs2b3412bsds": 'A',
    "&&aa33Y1ddsf4542": 'B',
    "&&i121iKhys3hi12": 'C',
    "&&ad2341asds242E": 'D',
    "&&3312fsf3W242d3": 'E',
    "&&752dsdfs213133": 'F',
    "&&5234sSfa12312d": 'G',
    "&&624hdhh351dsfs": 'H',
    "&&234s2zfs324222": 'I',
    "&&242qeVwr12312s": 'J',
    "&&21423afssf2342": 'K',//
    "&&adsD1423423ada": 'L',
    "&&24293sds12232a": 'M',
    "&&21313cssdsc123": 'N',
    "&&99oo67yaags76o": 'O',
    "&&aDd1212qeada12": 'P',
    "&&123D24sdsd1231": 'Q',
    "&&1232a2ssdad234": 'R',
    "&&2131d452sdada3": 'S',
    "&&a31dsVf4rsvhhg": 'T',
    "&&241zczxDXc23ad": 'U',
    "&&1312vxvsrt4556": 'V',
    "&&das3424S2sadz3": 'W',
    "&&wds24124dczD34": 'X',
    "&&asd12232s389fb": 'Y',
    "&&ad243D23dsfs32": 'Z'
  };

  return {
    // 根据 key 获取 value
    get: function(key) {
      return _data.hasOwnProperty(key) ? _data[key] : undefined;
    },

    // 获取所有键值对 (用于替换函数遍历)
    getAllEntries: function() {
      var entries = [];
      for (var key in _data) {
        if (_data.hasOwnProperty(key)) {
          entries.push({ key: key, value: _data[key] });
        }
      }
      return entries;
    },

    // (可选) 若需支持动态更新 Map，可暴露 set 方法
    set: function(key, value) {
      _data[key] = value;
    }
  };
})();

function replaceString(originalStr, map) {
  var result = originalStr;
  // 获取 Map 中所有键值对
  var entries = map.getAllEntries();

  // 遍历所有键值对进行替换
  for (var i = 0; i < entries.length; i++) {
    var entry = entries[i];
    var key = entry.key;
    var value = entry.value;

    // 处理特殊正则字符（如 . * + ? ^ $ ( ) [ ] { } | \）
    var escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // 创建全局匹配的正则表达式
    var regex = new RegExp(escapedKey, 'g');

    // 替换所有匹配的子串
    result = result.replace(regex, value);
  }

  return result;
}


// 处理混淆后的公钥
export async function dealDataGy() {
  if('test' == pppval) return '';
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(keyPart1 + replaceString(pppval, REPLACEMENT_MAP)+ deobfuscateKey(getywsj())+keyPart2)
  const kkk = await getVata()
  return encrypt.encrypt(kkk.data.data)
}

